export const DEFAULTGAP = 20
export const VERSION = '2025.09.18b'
export const VERSIONDESCRIPTION = `Odd Provider Tools 1.0 - Build ${VERSION}`

export const onLoginPayloadOverride = (login: string, pwd: string) => ({
  'login': login,
  'pwd': pwd
})

export const RoutesNames = {
  home: '/',
  login: '/login',
  mastersExample: '/masters-example',
  masterExample: '/masters-example/:id',
  childrenExample: '/chidren-example',
  childExample: '/chidren-example/:id',
  requiredAuthExample: '/required-auth-example',

  events: '/events',
  event: '/events/:id',
  participants: '/participants',
  participant: '/participants/:id',
  sports: '/sports',
  sport: '/sports/:id',
  tournaments: '/tournaments',
  tournament: '/tournaments/:id',
  locations: '/locations',
  location: '/locations/:id',

  tasks: '/tasks',
  task: '/tasks/:id',

  authorizations: '/authorizations',
  authorization: '/authorizations/:id',
  usersGroups: '/users-groups',
  userGroup: '/users-groups/:id',
  users: '/users',
  user: '/users/:id',
  logsClassifications: '/logs-classifications',
  logsClassification: '/logs-classifications/:id',
  logs: '/logs',

  companiesGroups: '/companiesgroups',
  companyGroup: '/companiesgroups/:id',
  companies: '/companies',
  company: '/companies/:id',

  scoreTypes: '/scoretypes',
  scoreType: '/scoretypes/:id'
}